function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.48,14.93c-.77-.84-2.25-1.22-4.38-1.22-1.19,.01-2.37,.12-3.54,.33-.75-.73-1.44-1.53-2.06-2.38-.47-.64-.9-1.3-1.29-1.98,.65-1.83,1.04-3.75,1.16-5.69,0-1.74-.71-3.6-2.64-3.6-.67,.01-1.28,.38-1.61,.96-.84,1.42-.51,4.31,.84,7.34-.45,1.35-.96,2.7-1.54,4.19-.5,1.27-1.1,2.49-1.8,3.66-1.98,.77-6.18,2.7-6.57,4.83-.15,.62,.08,1.27,.58,1.67,.48,.42,1.1,.63,1.74,.58,2.51,0,5.02-3.48,6.76-6.5,.97-.33,1.93-.64,2.97-.9,1.1-.26,2.12-.51,3.09-.71,2.7,2.31,5.09,2.7,6.25,2.7,1.61,0,2.25-.71,2.45-1.29,.27-.68,.11-1.46-.4-1.99Zm-1.74,1.22c-.06,.45-.58,.77-1.22,.77-.2,.01-.39,0-.58-.06-1.3-.34-2.51-.95-3.55-1.8,.85-.13,1.71-.19,2.57-.19,.58,.01,1.16,.05,1.74,.13,.59,.13,1.23,.39,1.04,1.16h0ZM10.22,1.93c.14-.2,.34-.34,.58-.39,.64,0,.77,.71,.77,1.35-.06,1.47-.32,2.91-.77,4.31-1.09-2.76-.96-4.63-.58-5.27h0Zm3.6,12.36c-.71,.13-1.42,.33-2.12,.51-.51,.13-1.03,.33-1.61,.45,.26-.58,.51-1.16,.77-1.67,.33-.71,.58-1.42,.84-2.12,.26,.39,.45,.71,.71,1.03,.45,.64,.96,1.22,1.42,1.8h0Zm-7.79,3.73c-1.61,2.57-3.22,4.25-4.12,4.25-.14,0-.27-.05-.38-.13-.18-.13-.26-.37-.19-.58,.13-.96,1.98-2.31,4.7-3.54h0Z",
    style: {
      fill: "#b30b00"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ee7dfce2f482a4ec8631155a7575156c.svg";
export { ForwardRef as ReactComponent };